<span class="mv-context-menu-title">
    <slot/>
</span>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "src/features/media-viewer/media-viewer.variables.less";

    .mv-context-menu-title {
        padding: @spacing-xs @spacing-s;
        font-size: @font-size-sm;
        font-weight: 500;
    }
</style>